import { render } from "./ModalCom1.vue?vue&type=template&id=28390a59&ts=true"
import script from "./ModalCom1.vue?vue&type=script&lang=ts"
export * from "./ModalCom1.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Users\\AloneX\\taipeitest\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__